const Login = {
  welcome_back: "Content de te revoir",
  remember_me: "Souviens-toi de moi",
  forgot_username_or_password: "Identifiant ou mot de passe oublié",
  i_dont_have_an_account: "je n'ai pas de compte",
};
export default Login;
